import {createElementAnd, dmy, raf} from "../util";

export class BookingModuleVB {

    constructor(el) {
        this.el = el;
        this.accommodationId = parseInt(this.el.dataset.accommodationId || "0");
        this.campingId = parseInt(this.el.dataset.campingId || "0");

        if (this.accommodationId === 0 || this.campingId === 0)
            throw new Error("Missing data-accommodation-id or data-camping-id");

        this.currentPeriod = "week";
        this.isLoading = false;
        this.lastStartDate = "";

        Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-load-more]")).forEach(el => el.addEventListener("click", evt => this.onLoadMoreClicked(evt)));
        Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-period]")).forEach(el => el.addEventListener("click", evt => this.onPeriodChanged(evt)));

        setTimeout(() => this.el.querySelector("li.active [data-booking-period]").click(), 250);
    }

    clearAvailability() {
        const table = this.el.querySelector("[data-booking-table]");
        const tableBody = table.querySelector("tbody");

        tableBody.innerHTML = "";
    }

    loadAvailability(startDate, limit) {
        if (this.isLoading)
            return;

        this.setLoading(true);

        startDate = startDate || "";
        limit = limit || 5;

        if (startDate === "")
            startDate = dmy();

        Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-no-results]")).forEach(el => el.style.setProperty("display", "none"));

        fetch(`/api/booking/vb/availability/${this.campingId}/${this.accommodationId}/${this.currentPeriod}/${startDate}?limit=${limit}`)
            .then(r => r.json())
            .then(r => this.onAvailabilityResponse(r))
            .catch(err => console.error(err));
    }

    setLoading(isLoading = true) {
        this.isLoading = isLoading;

        if (isLoading) {
            Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-load-more]")).forEach(el => el.style.setProperty("display", "none"));
            Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-loader]")).forEach(el => el.style.setProperty("display", "block"));
        } else {
            Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-load-more]")).forEach(el => el.style.setProperty("display", "block"));
            Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-loader]")).forEach(el => el.style.setProperty("display", "none"));
        }

        Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-no-results]")).forEach(el => el.style.setProperty("display", "none"));

        if (this.lastStartDate === null) {
            Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-load-more]")).forEach(el => el.style.setProperty("display", "none"));
            Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-no-results]")).forEach(el => el.style.setProperty("display", "block"));
        }
    }

    onAvailabilityResponse(response) {
        if (response && response.data && response.data.error) {
            const alert = container.querySelector("div.alert");
            const container = this.el.querySelector("[data-booking-table]").parentNode;

            if (alert)
                alert.parentNode.removeChild(alert);

            container.appendChild(createElementAnd("div", div => {
                div.classList.add("alert", "alert-danger");
                div.innerHTML = `<strong>${response.data.error.id}:</strong>${response.data.error.message}`;
            }));

            console.error(`${response.data.error.id}: ${response.data.error.message}`);
            this.lastStartDate = null;
        } else {
            const table = this.el.querySelector(`[data-booking-table="${this.currentPeriod}"]`);
            const tableBody = table.querySelector("tbody");

            this.lastStartDate = response.data.last_date_str;

            for (let result of response.data.results) {
                let dateStr = `${result.from_date_str} &ndash; ${result.to_date_str}`;
                let priceStr = result.price_str;
                let priceBeforeStr = "";
                let onSale = false;
                let title = result.description;

                if (this.currentPeriod === "speciaal" && result.arrangements && result.arrangements[0]) {
                    priceStr = result.arrangements[0].price_str;
                    title = result.arrangements[0][`description_${hcdcI18n.locale}`];
                } else if (result.price_before > result.price) {
                    priceBeforeStr = result.price_before_str;
                    onSale = true;
                }

                tableBody.appendChild(createElementAnd("tr", tr => {
                    if (onSale)
                        tr.classList.add("on-sale");

                    tr.innerHTML = `<td class="book-period">${title !== null ? `<strong>${title}</strong><br/>` : ``}${dateStr}</td>
									<td class="book-price"><span class="price-before">${priceBeforeStr}</span>${priceStr}</td>
									<td class="book-action"><a href="${result.booking_url}" target="_blank" class="btn btn-primary btn-sm">${hcdcI18n.book_now}</a></td>`;
                }));
            }

            this.el.querySelector("[data-booking-no-results]").style.setProperty("display", "block");
        }

        this.setLoading(false);
    }

    onLoadMoreClicked(evt) {
        evt.preventDefault();

        this.loadAvailability(this.lastStartDate);
    }

    onPeriodChanged(evt) {
        if (this.isLoading) {
            evt.preventDefault();
            return;
        }

        this.currentPeriod = event.target.dataset.bookingPeriod;

        const table = this.el.querySelector(`[data-booking-table="${this.currentPeriod}"]`);
        const tableBody = table.querySelector("tbody");

        tableBody.innerHTML = "";

        this.loadAvailability("", 5);
    }

}
